module.exports = __webpack_public_path__ + "static/img/cwgl_p3.dd718c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/cwgl_p3.png
// module id = RO4B
// module chunks = 2